import { render, staticRenderFns } from "./sort-vessel.vue?vue&type=template&id=8f25f03c&scoped=true"
import script from "./sort-vessel.vue?vue&type=script&lang=js"
export * from "./sort-vessel.vue?vue&type=script&lang=js"
import style0 from "./sort-vessel.vue?vue&type=style&index=0&id=8f25f03c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f25f03c",
  null
  
)

export default component.exports